import { render, staticRenderFns } from "./SearchHospital.vue?vue&type=template&id=2285f2f2"
import script from "./SearchHospital.vue?vue&type=script&lang=js"
export * from "./SearchHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports